import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box, Row, TableList, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { Attachments } from '~/components/Attachments/Attachments';
import { emptyCell } from '~/constants';
import { useLocaleKeys } from '~/i18n';
import { utils } from '~/utils';
import { VendorLineItem, CustomerLineItem } from './LineItem/LineItem';
import styles from './ScheduledInvoice.module.scss';
import { getColumnDefs, HeaderDateIndicator, scheduledInvoiceColumnsTextsPath } from './ScheduledInvoice.utils';
const deprecatedTestIds = {
    ScheduledInvoiceTestIds: {
        Root: 'scheduled-invoice',
        IssueDate: 'scheduled-invoice-issue-date',
        DueOnDate: 'scheduled-invoice-due-on-date',
        RowsContainer: 'scheduled-invoice-rows-container',
        TotalAmountRow: 'total-amount-row'
    }
};
export const GetScheduledInvoiceTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds
    });
export default function ScheduledInvoice(props) {
    const { t: scheduledInvoiceTexts } = useLocaleKeys('pages.agreementMinisite.scheduledInvoice');
    const { t: agreementMinisiteTexts } = useLocaleKeys('pages.agreementMinisite');
    const { t: columnsTexts } = useLocaleKeys(scheduledInvoiceColumnsTextsPath);
    const { ScheduledInvoiceTestIds } = useMemo(()=>GetScheduledInvoiceTID(), []);
    const ScheduledInvoiceTableRow = props.isVendor ? VendorLineItem : CustomerLineItem;
    const columnDefs = useMemo(()=>getColumnDefs(columnsTexts), []);
    const { compact = false } = props;
    return /*#__PURE__*/ _jsx(TableList.Provider, {
        variant: "minimal",
        columnDefs: columnDefs,
        justifyBetween: true,
        children: /*#__PURE__*/ _jsxs("div", {
            className: styles.root,
            "data-testid": ScheduledInvoiceTestIds.Root(),
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.infoRow,
                    children: [
                        /*#__PURE__*/ _jsx(HeaderDateIndicator, {
                            label: scheduledInvoiceTexts.issueDate(),
                            date: props.issueDate,
                            testId: ScheduledInvoiceTestIds.IssueDate()
                        }),
                        /*#__PURE__*/ _jsx(HeaderDateIndicator, {
                            label: scheduledInvoiceTexts.dueOn(),
                            date: props.paymentDate,
                            testId: ScheduledInvoiceTestIds.DueOnDate()
                        })
                    ]
                }),
                !compact && /*#__PURE__*/ _jsx(TableList.Header, {
                    className: styles.header,
                    bgColor: "darkGray",
                    items: columnDefs
                }),
                props.rowsProps.length ? /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            "data-testid": ScheduledInvoiceTestIds.RowsContainer(),
                            className: compact ? styles.rowsContainerMobile : undefined,
                            children: [
                                props.rowsProps.map((rowProps)=>/*#__PURE__*/ _jsx(ScheduledInvoiceTableRow, _object_spread_props(_object_spread({}, rowProps), {
                                        addedLineItemId: props.addedLineItemId,
                                        compact: compact
                                    }), rowProps.charge.id)),
                                !compact && /*#__PURE__*/ _jsx(TableList.Row, {
                                    className: styles.footerRow,
                                    items: [
                                        emptyCell,
                                        emptyCell,
                                        {
                                            value: /*#__PURE__*/ _jsx(Typography, {
                                                variant: "paragraph1",
                                                children: scheduledInvoiceTexts.subtotal()
                                            })
                                        },
                                        emptyCell,
                                        {
                                            value: /*#__PURE__*/ _jsx(Typography, {
                                                weight: "normal",
                                                children: utils.formatDollarAmount(props.totalAmount)
                                            })
                                        },
                                        emptyCell,
                                        emptyCell
                                    ],
                                    testId: ScheduledInvoiceTestIds.TotalAmountRow()
                                }),
                                props.attachments && props.isVendor && /*#__PURE__*/ _jsx(Box, {
                                    className: styles.attachments,
                                    children: /*#__PURE__*/ _jsx(Attachments, {
                                        disableDownloadLinks: true,
                                        files: props.attachments.files,
                                        onRemove: props.attachments.onRemove
                                    })
                                })
                            ]
                        }),
                        compact && /*#__PURE__*/ _jsxs(Row, {
                            className: styles.mobileFooterRow,
                            justifyContent: "space-between",
                            alignItems: "center",
                            testId: ScheduledInvoiceTestIds.TotalAmountRow(),
                            children: [
                                /*#__PURE__*/ _jsx(Typography, {
                                    variant: "paragraph2",
                                    weight: "normal",
                                    children: scheduledInvoiceTexts.subtotal()
                                }),
                                /*#__PURE__*/ _jsx(Typography, {
                                    variant: "paragraph2",
                                    weight: "normal",
                                    children: utils.formatDollarAmount(props.totalAmount)
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ _jsxs(Typography, {
                    variant: "paragraph1",
                    className: styles.empty,
                    children: [
                        agreementMinisiteTexts.scheduledInvoiceEmpty1(),
                        /*#__PURE__*/ _jsx("br", {}),
                        agreementMinisiteTexts.scheduledInvoiceEmpty2()
                    ]
                })
            ]
        })
    });
}
